import { render, staticRenderFns } from "./ExerciseFormContent.vue?vue&type=template&id=447da45c"
import script from "./ExerciseFormContent.vue?vue&type=script&lang=js"
export * from "./ExerciseFormContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports